import { Link } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{site.intro}</p>
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary-800 px-3 py-1 text-xs font-label text-accent-300">
              <i className="ri-pulse-line"></i>
              榜单实时滚动更新
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href.startsWith("/about") ? "/about" : "/"}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to="/"
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-2 text-sm text-background-200">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                {site.email}
              </li>
              <li className="flex items-start gap-2 text-sm text-background-200">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                {site.replyTime}
              </li>
              <li className="flex items-start gap-2 text-sm text-background-200">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-shield-check-line"></i>
                </span>
                内容以公开讨论为参考，理性围观
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col gap-3 px-4 py-5 text-xs font-label text-background-300 md:flex-row md:items-center md:justify-between md:px-6">
          <p>
            © {year} {site.name}（{site.domain}）. 保留所有权利。
          </p>
          <p className="text-background-300">
            本站内容来源于公开讨论的整理与呈现，如对内容有异议可通过邮箱反馈。
          </p>
        </div>
      </div>
    </footer>
  );
}